import ProductDropdown from '@components/pages/Product/components/ProductDropdown/ProductDropdown';
import styles from '@components/components/ProductComponentsLegacy/ProductCardOptions/ProductCardOptions.module.scss';
import React from 'react';
import classNames from 'classnames';

const ProductCardOptionsLegacy = ({
  product,
  options,
  productOption,
  handleDropdownChange,
}) => (
  <div className={classNames('ProductCardList-equal-height', styles.dropdown)}>
    {options?.bindung && (
      <ProductDropdown
        dataPurpose="Vertragsbindung"
        items={options?.bindung}
        label="Vertrags&shy;bindung:"
        name="Vertragsbindung"
        onSelect={value => {
          handleDropdownChange({ product, option: 'bindung', value });
        }}
        selectedItem={productOption?.bindung}
      />
    )}
    {options?.mixtype && (
      <ProductDropdown
        dataPurpose="Zusammensetzung"
        items={options?.mixtype}
        label="Zusammen&shy;setzung:"
        name="Zusammensetzung"
        onSelect={value => {
          handleDropdownChange({ product, option: 'mixtype', value });
        }}
        selectedItem={productOption?.mixtype}
      />
    )}
    {options?.capprice && (
      <ProductDropdown
        dataPurpose="Preisobergrenze"
        items={options?.capprice}
        label="Preis&shy;obergrenze:"
        name="Preisobergrenze"
        onSelect={value => {
          handleDropdownChange({ product, option: 'capprice', value });
        }}
        selectedItem={productOption?.capprice}
      />
    )}
  </div>
);

export default ProductCardOptionsLegacy;
